<template>
  <div id="eloBatch">
    <b>ELOバッチ実行画面</b><br/><br/>

    <table>
      <tr>
        <td>ELOバッチを実行いただきます。</td>
      </tr>
    </table><br/>
    <span id="batchBtns">
    <h2>基本評価：</h2>
    <button id="gameCreateBtn" v-on:click="gameCreateClick('normal')" class="btn-mid" style="width:500px;">基本評価バッチ実行(Game Create)</button>&nbsp;
    <button id="gameClearBtn" v-on:click="gameClearClick('normal')" class="btn-mid" style="width:500px;">基本評価バッチ実行(Reset)</button><br/>
    <button id="gameRunBtn" v-on:click="gamePlayClick('normal')" class="btn-mid" style="width:500px;">基本評価バッチ実行(Game Play)</button><br/>
    <h2>横断評価：</h2>
　　<button id="directEvalGameCreateBtn" v-on:click="gameCreateClick('DirectEval')" class="btn-mid" style="width:500px;">横断評価バッチ実行(Game Create)</button>&nbsp;
    <button id="directEvalGameClearBtn" v-on:click="gameClearClick('DirectEval')" class="btn-mid" style="width:500px;">横断評価バッチ実行(Reset )</button><br/>
    <button id="directEvalGameRunBtn" v-on:click="gamePlayClick('DirectEval')" class="btn-mid" style="width:500px;">横断評価バッチ実行(Game Play)</button><br/>
    </span>
    <button @click="$router.back(-1);" class="btn-mid" style="width:300px;">キャンセル</button><br/>
  </div>
</template>

<script>
  export default {
    name: "eloBatch",
    methods: {
      gameCreateClick: function (mode) {
        var self = this;
        $("#batchBtns button").attr("disabled", true);
        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          //var data = self.$route.params;
          var data = {mode:mode};
          common.getAxios().post(process.env.API_URL +"/api/EloBatchGameCreate", data)
            .then(function (res) {
              $("#batchBtns button").attr("disabled", false);
              // 処理正常の場合
              if (res.data == '') {
                alert(res.data);
              }
              // 処理エラーの場合
              else {
                alert(res.data);
              }
            })
            .catch(function (err) {
              $("#batchBtns button").attr("disabled", false);
              alert(err);
            });
        });
      },
      gameClearClick: function (mode) {
        var self = this;
        $("#batchBtns button").attr("disabled", true);

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          //var data = self.$route.params;
          var data = {mode:mode};
          common.getAxios().post(process.env.API_URL +"/api/EloBatchGameReset", data)
            .then(function (res) {
              $("#batchBtns button").attr("disabled", false);
              // 処理正常の場合
              if (res.data == '') {
                alert(res.data);
              }
              // 処理エラーの場合
              else {
                alert(res.data);
              }
            })
            .catch(function (err) {
              $("#batchBtns button").attr("disabled", false);
              alert(err);
            });
        });
      },
      gamePlayClick: function (mode) {
        var self = this;
        $("#batchBtns button").attr("disabled", true);
        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          //var data = self.$route.params;
          var data = {mode:mode};
          common.getAxios().post(process.env.API_URL +"/api/EloBatchGamePlay", data)
            .then(function (res) {
              $("#batchBtns button").attr("disabled", false);
              // 処理正常の場合
              if (res.data == '') {
                alert(res.data);
              }
              // 処理エラーの場合
              else {
                alert(res.data);
              }
            })
            .catch(function (err) {
              $("#batchBtns button").attr("disabled", false);
              alert(err);
            });
        });
      },

    }
  };
</script>



// WEBPACK FOOTER //
// eloBatch.vue?59bf7102